import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../Components/Loader/Loader';
import {
  checkDocument,
  downloadDocument,
  formatTimestamp,
  getDocumentListing,
  isGreater,
  sendForEsign,
  viewMergedFile,
} from '../../Utils/utils';
import './UploadDocument.scss';

function isValidJson(jsonString) {
  try {
    jsonString = JSON.parse(jsonString);
    if (typeof jsonString !== 'object')
      return false;
    return true;
  } catch (error) {
    return false;
  }
}

const Listing = () => {
  const [listingData, setListingData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [dataToRender, setDataToRender] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pagination, setPagination] = useState(1);
  const [selectedOptionMap,setSelectedOptionMap]=useState({})

 

  useEffect(() => {
    getDocumentListing({ setShowLoader, setListingData });
  }, []);

  const populateSelectedOptions = (alldata) => {
    const updatedSelectedOptions = {};
  
    alldata.forEach((data) => {
      updatedSelectedOptions[data.document_id] = 'email';
    });
  
    setSelectedOptionMap(updatedSelectedOptions);
  };

      
      // selectedOptionMap[data.document_id]="email"
  

    // console.log("map is")
    // console.log(selectedOptionMap)

    

  
  useEffect(() => {

    const filteredData = listingData?.filter(
      (item) =>
      
        
        item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.mobile.includes(searchQuery) ||
        item.transaction_key_value.includes(searchQuery)
    );
    let currentData = searchQuery?.length ? filteredData : listingData;

    // console.log("Current page is")
    // console.log(currentData)

    populateSelectedOptions(currentData);

    const itemsPerPage = 10; // Number of items to show per page

    setPagination(currentData.length / itemsPerPage);
    // let totalDataToRender = dataToRender;
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setDataToRender(currentData?.slice(startIndex, endIndex));
  }, [searchQuery, listingData, currentPage]);

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  if (dataToRender.length) {
    dataToRender.map((item) => {
      if (!isValidJson(item?.text_response)) {
        item.text_response = null;
      }
    });
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col" id="Listingview">
          <div className="row mrg-t30">
            <div className="col-lg-12">
              <h2>Manage Documents</h2>
            </div>
            <div className="col-lg-4 mrg-t30">
              <input
                className="searchbar"
                type="text"
                value={searchQuery}
                onChange={handleSearchInputChange}
                placeholder="Search by name, email, or mobile"
              />
            </div>

            <div className="col-lg-4 mrg-t30"> &nbsp;</div>
            <div className="col-lg-4 mrg-t30">
              <Link className="button add-documents" to="/documents">
                Add Documents
              </Link>
            </div>
          </div>

          <div className="table-responsive" id="tableListing">
            {showLoader && <Loader />}
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Order No/Sell Bill No</th>
                  <th>Merged File</th>
                  <th>Document Created</th>
                  <th>Esign Requested</th>
                  <th>Action</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {dataToRender?.length === 0 ? (
                  <tr>
                    <td colSpan="10" style={{ textAlign: 'center' }}>
                      No record found. Please add documents to display.
                    </td>
                  </tr>
                ) : (
                  dataToRender?.length > 0 &&
                  dataToRender.map((item, index) => (
                    <tr key={item.name + index + 1}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.mobile}</td>
                      <td>{Object.values(JSON.parse(item?.transaction_key_value) || {})?.[0] || ''}</td>
                      <td>
                        <span className="actionLinks viewlink" onClick={() => viewMergedFile({ jsonData: item, setShowLoader })}>
                          {' '}
                          View
                        </span>
                      </td>
                      <td>{item?.item_created_date ? formatTimestamp(item?.item_created_date) : ''}</td>
                      <td>{!!item.text_response && JSON.parse(item.text_response).sign_request_details.requested_on}</td>

                      <td>
                        {!item.text_response && (

                          <>

                            {/* Radio Button for email and phone  */}

                            <div className="radio-btn">
                              <label className="emailId">
                               
                                <input
                                  type="radio"
                                  name={item?.document_id}
                                  value="email"
                                 checked={selectedOptionMap[item.document_id]==="email"}
                                onChange={
                                  (e)=>{
                                    setSelectedOptionMap((pre)=>{return {...pre,[item.document_id]:e.target.value}})
                                  }
                                }
                                />
                                &nbsp;
                                Email

                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name={item?.document_id}
                                  value="phone"
                                  checked={selectedOptionMap[item.document_id]==="phone"}
                                  onChange={

                                    (e)=>{
                                      setSelectedOptionMap((pre)=>{return {...pre,[item.document_id]:e.target.value}})
                                     
                                    
                                    }
                                  
                                  }
                              
                                />
                                &nbsp;
                                
                                Phone
                              </label>

                            </div>

                            {/*  */}

                            <span
                              className="actionLinks greenl"
                              style={{ color: 'green' }}
                              onClick={() =>
                                sendForEsign({
                                  jsonData: item,
                                  mode:selectedOptionMap[item.document_id],
                                  setListingData,
                                  setShowLoader,
                                })
                              }
                            >

                              Esign Document
                            </span>

                          </>
                        )}
                        {item.text_response && item.self_signed_status && (
                          <span
                            className="actionLinks bluel"
                            style={{ color: 'blue' }}
                            onClick={() =>
                              downloadDocument({
                                jsonData: item,
                                setShowLoader,
                              })
                            }
                          >
                            Download Esign Document
                          </span>
                        )}
                        {item.text_response &&
                          !item.self_signed_status &&
                          !isGreater(JSON.parse(item.text_response).sign_request_details.expire_on) && (
                            <span
                              className="actionLinks redl"
                              style={{ color: 'red' }}
                              onClick={() =>
                                checkDocument({
                                  jsonData: item,
                                  setShowLoader,
                                  setListingData,
                                })
                              }
                            >
                              Check Document
                            </span>
                          )}
                        {item.text_response &&
                          !item.self_signed_status &&
                          isGreater(JSON.parse(item.text_response).sign_request_details.expire_on) && (
                            <span
                              className="actionLinks bluel"
                              style={{ color: 'blue' }}
                              onClick={() =>
                                sendForEsign({
                                  jsonData: item,
                                  setShowLoader,
                                  setListingData,
                                  is_resend: true,
                                })
                              }
                            >
                              Resend
                            </span>
                          )}
                      </td>
                      <td>
                        {item.text_response && isGreater(JSON.parse(item.text_response).sign_request_details.expire_on) ? (
                          <span>Expired</span>
                        ) : !item.text_response ? (
                          <span>Ready</span>
                        ) : item.text_response && !item.self_signed_status ? (
                          <span>Requested</span>
                        ) : (
                          <span>Success</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            {Array.from({ length: Math.ceil(pagination) }, (_, index) => (
              <button key={index} onClick={() => handlePageChange(index)} className={currentPage === index ? 'active' : ''}>
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listing;
